import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { visualizarReporteEnPdf,generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormCaja07 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            anioActual: null,

            //CONTROL SOBRE PANTALLA
            control: 0,
        };

        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.totalSemanaCobranza = this.totalSemanaCobranza.bind(this);
        this.consolidadoCobranza = this.consolidadoCobranza.bind(this);
        this.consolidadoimprimirExcel = this.consolidadoimprimirExcel.bind(this);
        this.CobranzaItera = this.CobranzaItera.bind(this);
        this.DetalleReciboItera= this.DetalleReciboItera.bind(this);

    }

    //METHODS
    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    //Consulta DB
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //REACT CYCLE
    componentDidMount(){

        this.props.generar_LogAuditoriaIngresoForm('0507').then(()=>{            
            let fechaProceso = getFechaProcesoPorModulo('05');
            this.setState({fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'), fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'), anioActual: fechaProceso.split('/')[2] })
        })
        .catch((error )=>{
            alert(error.response?error.response.data.msg:error.message);
            this.setState({control: 1});
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0507');
    }

    //ACTION BUTTONS
    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('05');
        this.setState({fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'), fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'), 
        anioActual: fechaProceso.split('/')[2] })
    }

    totalSemanaCobranza(){
        var errors = '';
        var proceder = true;
        var fechaOK = true;

        if(this.state.fechaDesde === null){
            proceder = false;
            fechaOK = false;
            errors+=` - Ingrese una fecha desde\n`;
        }

        if(this.state.fechaHasta === null){
            proceder = false;
            fechaOK = false;
            errors+=` - Ingrese una fecha hasta`;
        }

        if(this.state.fechaDesde !== null && this.state.fechaHasta !== null){

            var monthDesde = this.state.fechaDesde.format('MM');
            var yearDesde  = this.state.fechaDesde.format('YYYY');

            let monthHasta = this.state.fechaHasta.format('MM');
            let yearHasta  = this.state.fechaHasta.format('YYYY');

            if(monthDesde !== monthHasta){
                proceder = false;
                fechaOK = false;
                errors+=` - Las fechas deben estar dentro del mismo mes\n`;
            }
            
            if(yearDesde!== yearHasta){
                proceder = false;
                fechaOK = false;
                errors+=` - Las fechas deben estar detro del mismo año\n`;
            }
        }

        if(fechaOK === true){
            this.verificaPresupuestoPeriodo(yearDesde, monthDesde).then((result)=>{
                let resultado = result;
                if(resultado.value===false){
                    proceder = false;
                    errors += resultado.msg; 
                }
    
                if(proceder===true){
                    var parametros = ""
                    parametros = '&rpt=70&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
        
                    visualizarReporteEnPdf(parametros);
                }else{
                    alert(errors)
                }
            });
        }
    }

    DetalleReciboItera(){
        var errors = '';
        var proceder = true;
        

        if(this.state.fechaDesde === null){
            proceder = false;
            errors+=` - Ingrese una fecha desde\n`;
        }

        if(this.state.fechaHasta === null){
            proceder = false;
            errors+=` - Ingrese una fecha hasta`;
        }

        if(this.state.fechaDesde !== null && this.state.fechaHasta !== null){
            

            if(proceder===true){
                var parametros = ""
                parametros = '&rpt=163&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
    
                visualizarReporteEnPdf(parametros);
            }else{
                alert(errors)
            }
        }
    }
            


    CobranzaItera(){
        var errors = '';
        var proceder = true;
        

        if(this.state.fechaDesde === null){
            proceder = false;
            errors+=` - Ingrese una fecha desde\n`;
        }

        if(this.state.fechaHasta === null){
            proceder = false;
            errors+=` - Ingrese una fecha hasta`;
        }

        if(this.state.fechaDesde !== null && this.state.fechaHasta !== null){
            /*
            var monthDesde = this.state.fechaDesde.format('MM');
            var yearDesde  = this.state.fechaDesde.format('YYYY');

            let monthHasta = this.state.fechaHasta.format('MM');
            let yearHasta  = this.state.fechaHasta.format('YYYY');

            if(monthDesde !== monthHasta){
                proceder = false;
                errors+=` - Las fechas deben estar dentro del mismo mes\n`;
            }
            
            if(yearDesde!== yearHasta){
                proceder = false;
                errors+=` - Las fechas deben estar detro del mismo año\n`;
            }*/
            

            if(proceder===true){
                var parametros = ""
                parametros = '&rpt=59&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
    
                visualizarReporteEnPdf(parametros);
            }else{
                alert(errors)
            }
            

        }
    }

    consolidadoCobranza(){
        
        let dataEnvio = {};


        if(this.state.fechaDesde !== null && this.state.fechaHasta !== null){

            var parametros = ""
            dataEnvio.fechaDesde = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
            dataEnvio.fechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);

            parametros = '&rpt=161&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
            try{
                let config_request = {
                method: 'POST',
                url: '/cobranzaconsoli',
                data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    visualizarReporteEnPdf(parametros);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
                }catch(error){
                    alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
                }
        }
    }

    
    consolidadoimprimirExcel(){
      
        let dataEnvio = {};

        if(this.state.fechaDesde !== null && this.state.fechaHasta !== null){

            
            var parametros = ""
            dataEnvio.fechaDesde = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
            dataEnvio.fechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);

            parametros = '&rpt=162&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
            try{
                let config_request = {
                method: 'POST',
                url: '/cobranzaconsoli',
                data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    generarReporteEnExcel(parametros);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
                }catch(error){
                    alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
                }
        }
    }

    verificaPresupuestoPeriodo(year, month){
        return new Promise((resolve, reject)=>{
            global_axios.get(`/presupuestos?periodo=${year}`)
            .then((presupuestos)=>{
                console.log('ENTROOOOOOO!!', presupuestos)
                let result = {};
                let find = false;

                presupuestos.data.forEach((P)=>{                    
                    if(P.Mes === month && P.PMensual!==null){
                        find = true;
                    }
                })

                if(find===false){
                    result.value = false;
                    result.msg = ` - El periodo y mes seleccionados no tienen un presupuesto mensual asignado.\n`;
                }else{
                    result.value = true;
                    result.msg = '';
                }
                resolve(result); 
            })
            .catch((err)=>{                
                let result = {}
                result.value = false;
                result.msg = 'Revise los presupuestos antes de generar el reporte en el mes actual'
                resolve(result);
            });
        })
    }


    render(){
        return(
            <ContenedorForm porc_ancho='70'>
                <HeaderForm>
                    <TituloForm>Consolidado de cobranza</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>                
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <ContainerCol className='btn-group pull-right' margen_arriba='7'>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.fechaDesde===null || this.state.fechaHasta===null || this.state.control===1?true:false} onClick={this.totalSemanaCobranza}><i className="fa fa-print fa-lg" aria-hidden="true"/> Total Semana</button>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.fechaDesde===null || this.state.fechaHasta===null || this.state.control===1?true:false} onClick={this.CobranzaItera}><i className="fa fa-print fa-lg" aria-hidden="true"/> Aplicado Itera</button>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.fechaDesde===null || this.state.fechaHasta===null || this.state.control===1?true:false} onClick={this.DetalleReciboItera}><i className="fa fa-print fa-lg" aria-hidden="true"/> Detalle Recibo Itera</button>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.fechaDesde===null || this.state.fechaHasta===null || this.state.control===1?true:false} onClick={this.consolidadoCobranza}><i className="fa fa-print fa-lg" aria-hidden="true"/> Consolidado Inalambrik</button>
                                <button type='button' className='btn btn-success btn-sm' onClick={this.consolidadoimprimirExcel}><i className="fa fa-print fa-lg" aria-hidden="true"/> EXCEL Consolidado Inalambrik</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        departamento : state.sesion.valoresSesionForm.Departamento}
});
    
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading }, dispatch)
});
    
export default connect (mapStateToProps, mapDispatchToProps)(FormCaja07);